<template>
    <div class="lpm-operate-record-list">
        <el-table :data="tableData" border :max-height="maxHeight" v-loading="loading">
            <el-table-column prop="createUserName" label="操作人" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="operativeFunctionContent" label="操作内容" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div class="page-wrapper">
            <MPage ref="page"
                :current-page="page.pageNo"
                :pageData="pageConfig"
                :total="page.pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
            ></MPage>
        </div>
    </div>
</template>
<script>
import { selectOperativeRecord } from '../../../api/performManage.js'
import MPage from '@/components/supplierPanel/mPage/Main.vue';

export default {
    components: { MPage },
    props: {
        maxHeight: {
            type: String | Number,
            default() {
                return '300px';
            }
        }
    },
    data() {
        return {
            systemFlag: '',
            loading: false,
            performanceId: null,
            tableData: [],
            page: {
                pageTotal: 0,
                pageNo: 1,
                pageSize: 10
            },
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10,
                pageSizes: [10, 30, 50]
            },
        }
    },
    methods: {
        init(row) {
            // 测试数据 performanceId 可取 1
            // this.performanceId = 1
            this.performanceId = row.id
            this.page.pageNo = 1
            this.page.pageSize = 10
            //查看申诉：1，其他操作：2
            this.systemFlag = row.systemFlag || '2'
            this.loadData()
        },
        reset() {
            this.tableData = []
        },
        loadData() {
            this.loading = true
            const params = {
                performanceId: this.performanceId,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                systemFlag: this.systemFlag
            }
            selectOperativeRecord(params).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount
                    this.tableData = res.data.list
                }
            }).finally(() => {
                this.loading = false
            })
        },
        pageChange(val) {
            this.page.pageNo = val
            this.loadData()
        },
        sizeChange(val) {
            this.page.pageNo = 1
            this.page.pageSize = val
            this.loadData()
        },
    },
    mounted() {}
}
</script>
<style lang="less">
.lpm-operate-record-list {
    .page-wrapper {
        margin-top: 10px;
        height: 28px;
    }
}
</style>